import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../../components/FilterTable";
import { _HttpServices } from "../../../../_services/_HttpServices";
import Loader from "../../../../components/Loader";
import moment from "moment";
import { useHistory } from "react-router";
import getExcel from "../../../../_services/ExcelUtility";
import { Footer } from "../../../../components/Footer";

const AptevoProductTransfer = () => {
	const fileName = "Aptevo Product Transfer";
	const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
	const userData = JSON.parse(localStorage.getItem("userData"));
	const history = useHistory();
	const [productTransfer, setproductTransfer] = useState([]);
	const [loading, setLoading] = useState(false);
	const [hasError, setHasError] = useState(false);
	const columns = [
		{
			Header: "Account ID",
			accessor: "CustID",
			filter: "CustID",
			sortType: "basic",
		},
		{
			Header: "Cust PHS ID",
			accessor: "CustPHSID",
			filter: "CustPHSID",
			sortType: "basic",
		},
		{
			Header: "Org Name",
			accessor: "CustName",
			filter: "CustName",
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Account Address 1",
			accessor: "CustAddress",
			filter: "CustAddress",
			sortType: "basic",
			width: 220,
		},
		{
			Header: "Account City",
			accessor: "CustCity",
			filter: "CustCity",
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Account State",
			accessor: "CustState",
			filter: "CustState",
			sortType: "basic",
			width: 110,
		},
		{
			Header: "Account Zip",
			accessor: "CustZip",
			filter: "CustZip",
			sortType: "basic",
			width: 110,
		},
		{
			Header: "INVOICE #",
			accessor: "CustomersInvoice",
			filter: "CustomersInvoice",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Shipped Date",
			accessor: "CustomersInvoiceDate",
			filter: "CustomersInvoiceDate",
			sortType: "basic",
			width: 120,
			filterMethod: (filter, row) => {
				const rowValue = row.original;
				return rowValue.datefiled.includes(filter.value);
			},
		},
		{
			Header: "Contract Reference",
			accessor: "ContractReference",
			filter: "ContractReference",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Product NDC",
			accessor: "ProductNDC",
			filter: "ProductNDC",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "PRODUCT DESCRIPTION",
			accessor: "ProductDescription",
			filter: "ProductDescription",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Qty",
			accessor: "SaleQTY",
			filter: "SaleQTY",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Dosag OR Units tabs30",
			accessor: "DosagORUnitstabs30",
			filter: "DosagORUnitstabs30",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Report Start Time",
			accessor: "ReportStartTime",
			filter: "ReportStartTime",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Report End Time",
			accessor: "ReportENdTime",
			filter: "ReportENdTime",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Email ID",
			accessor: "EmailID",
			filter: "EmailID",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Invoice Number",
			accessor: "InvoiceNumber",
			filter: "InvoiceNumber",
			sortType: "basic",
			width: 150,
		},
		{
			Header: "Purchase Order Number",
			accessor: "PurchaseOrderNumber",
			filter: "PurchaseOrderNumber",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Ship To",
			accessor: "ShipTo",
			filter: "ShipTo",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship To ID",
			accessor: "ShipToID",
			filter: "ShipToID",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Ship From",
			accessor: "ShipFrom",
			filter: "ShipFrom",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From ID",
			accessor: "ShipFromID",
			filter: "ShipFromID",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Bill To",
			accessor: "BillTo",
			filter: "BillTo",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Bill To ID",
			accessor: "BillToID",
			filter: "BillToID",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Returns Quantity",
			accessor: "ReturnsQuantity",
			filter: "ReturnsQuantity",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Vendor Part Number",
			accessor: "VendorPartNumber",
			filter: "VendorPartNumber",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Manufacturer Part Number",
			accessor: "ManufacturerPartNumber",
			filter: "ManufacturerPartNumber",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "UPC",
			accessor: "UPC",
			filter: "UPC",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "SKU",
			accessor: "SKU",
			filter: "SKU",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Shipped Date",
			accessor: "ShippedDate",
			filter: "ShippedDate",
			sortType: "basic",
			width: 120,
		},
		{
			Header: "Promotion Number",
			accessor: "PromotionNumber",
			filter: "PromotionNumber",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Rebate Number",
			accessor: "RebateNumber",
			filter: "RebateNumber",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Effective Date Range",
			accessor: "EffectiveDateRange",
			filter: "EffectiveDateRange",
			sortType: "basic",
			width: 180,
		},
		{
			Header: "Ship To Address",
			accessor: "ShipTOAddress",
			filter: "ShipTOAddress",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship To city",
			accessor: "ShipTOcity",
			filter: "ShipTOcity",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship To State",
			accessor: "ShipTOState",
			filter: "ShipTOState",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship To ZipCode",
			accessor: "ShipTOZipCode",
			filter: "ShipTOZipCode",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From Address",
			accessor: "shipfromaddress",
			filter: "shipfromaddress",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From City",
			accessor: "shipfromcity",
			filter: "shipfromcity",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From State",
			accessor: "shipfromsate",
			filter: "shipfromsate",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Ship From ZipCode",
			accessor: "ShipfromZipCode",
			filter: "ShipfromZipCode",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Billing To Address",
			accessor: "BillingTOAddress",
			filter: "BillingTOAddress",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Billing To City",
			accessor: "BillingTOcity",
			filter: "BillingTOcity",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Billing To State",
			accessor: "BillingTOState",
			filter: "BillingTOState",
			sortType: "basic",
			width: 320,
		},
		{
			Header: "Billing To ZipCode",
			accessor: "BillingToZipCode",
			filter: "BillingToZipCode",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Total Line Count",
			accessor: "TotalLineCount",
			filter: "TotalLineCount",
			sortType: "basic",
			width: 80,
		},
		{
			Header: "Lot Number",
			accessor: "LotNumber",
			filter: "LotNumber",
			sortType: "basic",
			// width:320,
		},
		{
			Header: "Monetary Amount",
			accessor: "MonetaryAmount",
			filter: "MonetaryAmount",
			sortType: "basic",
			// width:320,
		},
		{
			Header: "Unit PriceCode",
			accessor: "UnitPriceCode",
			filter: "UnitPriceCode",
			sortType: "basic",
			// width:80,
		},
		{
			Header: "Unit of measure",
			accessor: "Unitofmeasure",
			filter: "Unitofmeasure",
			sortType: "basic",
			// width:80,
		},
	];

	useEffect(() => {
		getProductTransfer();
	}, []);

	async function getProductTransfer() {
		setLoading(true);
		let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}&FileFormat=${outbounddata.FileFormat}`;
		await _HttpServices
			.getData(url)
			.then((data) => {
				const productTransferResult = data.data;
				if (productTransferResult.length > 0) {
					let ind = 1;
					productTransferResult.map((res) => {
						res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format(
							"MM/DD/YYYY"
						);
						res.ShippedDate = moment(res.ShippedDate).format("MM/DD/YYYY");
						res.ReportStartTime = moment(res.ReportStartTime).format(
							"MM/DD/YYYY"
						);
						res.ReportENdTime = moment(res.ReportENdTime).format("MM/DD/YYYY");
						res.ind = ind++;
					});
				}
				setproductTransfer(productTransferResult);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
				setHasError(true);
			});
	}

	const EditRecords = () => {
		localStorage.setItem("productTransfer", JSON.stringify(productTransfer));
		history.push("/ProductTransferAddEdit");
	};

	return (
		<section className="content">
			<div className="page-title">
				<h2 className="h2">{fileName}</h2>
				{loading ? <Loader /> : null}
				<div>
					{productTransfer.length > 0 &&
						userData.RoleID === 1 &&
						outbounddata.Version_File === 0 &&
						(outbounddata.FileSentStatus === "Sent" ? (
							<Button type="submit" onClick={() => EditRecords()}>
								Create Reversal
							</Button>
						) : (
							<Button type="submit" onClick={() => EditRecords()}>
								Edit Records
							</Button>
						))}
					<Button
						type="submit"
						className="ml-2"
						onClick={() => getExcel(columns, productTransfer, fileName)}
					>
						<IoMdDownload className="icon btn-icon" />
						Download Excel{" "}
					</Button>
				</div>
			</div>
			<Row>
				<Col md={12}>
					<div className="card pt-2">
						<div className="card-body">
							<div className="inventory-grid">
								{hasError ? (
									<p>{`Error occurred. Unable to load ${fileName}.`}</p>
								) : (
									<Fragment>
										{productTransfer.length > 0 ? (
											<ReactTable
												columns={columns}
												data={productTransfer}
												defaultPageSize={10}
											/>
										) : (
											<div className="no-data">No data found.</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</Col>
			</Row>
			<Row>
				<Col md={12} className="text-right mt-2">
					<Button
						variant="danger"
						type="button"
						className="ml-3"
						onClick={() => history.goBack()}
					>
						<IoIosClose className="icon btn-icon" />
						Cancel
					</Button>
				</Col>
			</Row>
			<Footer />
		</section>
	);
};

export default AptevoProductTransfer;
